import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function Location(props) {
    return (
        <SvgIcon viewBox="0 0 48 48" {...props}>
            <g id="LocationIcon">
                <path d="M37,6.41A17.66,17.66,0,0,0,24.24,1h0a18,18,0,0,0-13,5.58,19.05,19.05,0,0,0-.24,26.33L22.06,46.18a2.32,2.32,0,0,0,1.77.82h0a2.32,2.32,0,0,0,1.77-.82L36.89,32.74A19.05,19.05,0,0,0,37,6.41ZM24,28.85A10.2,10.2,0,1,1,34.2,18.66,10.2,10.2,0,0,1,24,28.85Z" />
            </g>
        </SvgIcon>
    );
}

export default Location;